import { jsxs as D, jsx as u } from "react/jsx-runtime";
import * as j from "react";
import C, { useCallback as O, useState as P, useEffect as v } from "react";
import { Tag as _, classNames as X, useFoundation as z, matches as Y, createComponent as x, useClassNames as b, getDisplayName as J, mergeRefs as Q } from "@rmwc/base";
import { deprecatedClassNameMap as A, MDCListFoundation as d, strings as Z } from "@material/list";
import { withRipple as ee, RippleSurface as B } from "@rmwc/ripple";
import { Icon as V } from "@rmwc/icon";
const H = (i) => {
  if (!i)
    return !1;
  const e = i.getAttribute("tabindex");
  return e && Number(e) >= 0 ? (i.focus(), !0) : !1;
}, $ = (i, e) => {
  if (!i)
    return null;
  const n = e ? i.previousElementSibling : i.nextElementSibling;
  return n === null ? $(i.parentElement, e) : n;
}, M = class M extends C.Component {
  constructor(e) {
    super(e), this.childContainer = null, this.root = null, this.rafId = null, this.timerId = null, this.state = {
      open: !!this.props.defaultOpen || !!this.props.open,
      childrenStyle: {}
    }, this.handleClick = this.handleClick.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.handleFocus = this.handleFocus.bind(this);
  }
  static getDerivedStateFromProps(e, n) {
    return e.open !== void 0 && e.open !== n.open ? {
      ...n,
      open: e.open
    } : n;
  }
  componentDidMount() {
    this.syncOpenState();
  }
  componentDidUpdate(e, n) {
    n.open !== this.state.open && this.syncOpenState();
  }
  componentWillUnmount() {
    this.rafId && window.cancelAnimationFrame(this.rafId), this.timerId && window.clearTimeout(this.timerId);
  }
  syncOpenState() {
    const { onOpen: e, onClose: n } = this.props, r = {
      maxHeight: this.childContainer ? `${this.childContainer.offsetHeight}px` : "0px"
    };
    this.setState({ childrenStyle: r }, () => {
      this.state.open ? (e && e(), this.timerId = window.setTimeout(() => {
        this.state.open && this.setState({
          childrenStyle: {
            maxHeight: "none"
          }
        });
      }, 300)) : (n && n(), this.rafId = window.requestAnimationFrame(() => {
        this.setState({
          childrenStyle: {}
        });
      }));
    });
  }
  correctFocus(e) {
    this.rafId = window.requestAnimationFrame(() => {
      if (!this.state.open && this.root && this.root.contains(document.activeElement)) {
        const n = $(this.root, e);
        if (H(n))
          return;
        if (n) {
          const r = n.querySelectorAll("[tabindex]");
          for (let h = 0; h < r.length && !H(r[h]); h++)
            ;
        }
      }
    });
  }
  toggleOpen(e) {
    this.setState({ open: e });
  }
  handleClick(e) {
    const { handle: n } = this.props;
    n.props.onClick && n.props.onClick(e), this.toggleOpen(!this.state.open);
  }
  handleKeydown(e) {
    const { handle: n } = this.props;
    switch (n.props.onKeyDown && n.props.onKeyDown(e), e.key) {
      case "Enter":
        this.toggleOpen(!this.state.open);
        return;
      case "ArrowRight":
        this.toggleOpen(!0);
        return;
      case "ArrowUp":
      case "ArrowDown":
      case "Tab":
        const r = e.shiftKey || e.key === "ArrowUp";
        this.correctFocus(r);
        return;
      case "ArrowLeft":
        this.toggleOpen(!1);
        return;
    }
  }
  handleFocus(e) {
    if (!this.state.open && this.root && this.childContainer && this.childContainer.contains(document.activeElement)) {
      const n = this.root.querySelector(
        ".rmwc-collapsible-list__handle .mdc-deprecated-list-item"
      );
      n && n.focus();
    }
  }
  render() {
    const {
      children: e,
      handle: n,
      onOpen: r,
      onClose: h,
      open: f,
      defaultOpen: I,
      className: a,
      ...E
    } = this.props, { open: m, childrenStyle: S } = this.state;
    return /* @__PURE__ */ D(
      _,
      {
        ...E,
        onFocus: this.handleFocus,
        ref: (p) => this.root = p,
        className: X("rmwc-collapsible-list", a, {
          "rmwc-collapsible-list--open": m
        }),
        children: [
          /* @__PURE__ */ u("div", { className: "rmwc-collapsible-list__handle", children: C.cloneElement(n, {
            ...n.props,
            onClick: this.handleClick,
            onKeyDown: this.handleKeydown
          }) }),
          /* @__PURE__ */ u("div", { className: "rmwc-collapsible-list__children", style: S, children: /* @__PURE__ */ u(
            "div",
            {
              className: "rmwc-collapsible-list__children-inner",
              ref: (p) => this.childContainer = p,
              children: e
            }
          ) })
        ]
      }
    );
  }
};
M.displayName = "CollapsibleList";
let G = M;
const te = (i) => {
  const e = O((s) => s ? [].slice.call(
    s.querySelectorAll(
      `.${A[d.cssClasses.LIST_ITEM_CLASS]}`
    )
  ) : [], []), n = (s) => {
    const o = s.querySelector(
      `.${A[d.cssClasses.LIST_ITEM_PRIMARY_TEXT_CLASS]}`
    );
    if (o)
      return (o == null ? void 0 : o.textContent) ?? "";
    const t = s.querySelector(
      `.${A[d.cssClasses.LIST_ITEM_TEXT_CLASS]}`
    );
    return t && t.textContent || "";
  }, [r, h] = P(
    {}
  ), [f, I] = P(void 0), { foundation: a, ...E } = z({
    props: i,
    api: ({
      rootEl: s,
      foundation: o
    }) => {
      const t = o.adapter;
      return {
        listElements: () => e(s.ref),
        focusRoot: () => s == null ? void 0 : s.ref.focus(),
        getClasses: () => A[d.cssClasses.LIST_ITEM_CLASS],
        addClassToElementIndex: t.addClassForElementIndex,
        removeClassFromElementAtIndex: t.removeClassForElementIndex,
        setAttributeForElementIndex: t.setAttributeForElementIndex,
        getListItemCount: t.getListItemCount,
        focusItemAtIndex: t.focusItemAtIndex,
        selectedIndex: d.numbers.UNSET_INDEX,
        setSelectedIndex: (l) => o.setSelectedIndex(l)
      };
    },
    elements: { rootEl: !0 },
    foundation: ({ rootEl: s, emit: o }) => new d({
      getListItemCount: () => e(s.ref).length,
      getFocusedElementIndex: () => e(s.ref).indexOf(
        document.activeElement
      ),
      getAttributeForElementIndex: (t, l) => e(s.ref)[t].getAttribute(l),
      listItemAtIndexHasClass: (t, l) => {
        const c = e(s.ref)[t];
        return !!(c != null && c.classList.contains(
          A[l]
        ));
      },
      setAttributeForElementIndex: (t, l, c) => {
        l === "tabindex" && (l = "tabIndex");
        const T = e(s.ref)[t];
        T && T.setAttribute(l, String(c));
      },
      addClassForElementIndex: (t, l) => {
        h((c) => c[t] && c[t].indexOf(l) > -1 ? c : c[t] && c[t].indexOf(l) === -1 ? {
          ...c,
          [t]: [...c[t], l]
        } : { ...c, [t]: [l] });
      },
      removeClassForElementIndex: (t, l) => {
        h((c) => c[t] && c[t].indexOf(l) > -1 ? {
          ...c,
          [t]: c[t].filter((T) => T !== l)
        } : c);
      },
      focusItemAtIndex: (t) => {
        const l = e(s.ref)[t];
        l && l.focus();
      },
      setTabIndexForListItemChildren: (t, l) => {
        const c = e(s.ref)[t];
        [].slice.call(
          c.querySelectorAll(
            d.strings.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX
          )
        ).forEach(
          (k) => k.setAttribute("tabindex", String(l))
        );
      },
      hasCheckboxAtIndex: (t) => !!e(s.ref)[t].querySelector(
        d.strings.CHECKBOX_SELECTOR
      ),
      hasRadioAtIndex: (t) => !!e(s.ref)[t].querySelector(
        d.strings.RADIO_SELECTOR
      ),
      isCheckboxCheckedAtIndex: (t) => {
        const c = e(s.ref)[t].querySelector(
          d.strings.CHECKBOX_SELECTOR
        );
        return c ? c.checked : !1;
      },
      setCheckedCheckboxOrRadioAtIndex: (t, l) => {
        const T = e(s.ref)[t].querySelector(
          d.strings.CHECKBOX_RADIO_SELECTOR
        );
        if (T) {
          T.checked = l;
          const k = document.createEvent("Event");
          k.initEvent("change", !0, !0), T.dispatchEvent(k);
        }
      },
      notifyAction: (t) => o("onAction", { index: t }),
      notifySelectionChange: (t) => o(Z.SELECTION_CHANGE_EVENT, { changedIndices: t }, !0),
      isFocusInsideList: () => {
        var t;
        return !!((t = s.ref) != null && t.contains(document.activeElement));
      },
      isRootFocused: () => document.activeElement === s.ref,
      getPrimaryTextAtIndex: (t) => n(e(s.ref)[t])
    })
  }), { rootEl: m } = E, S = O(
    (s) => {
      let o = s.target, t = -1;
      for (; o && !o.classList.contains(
        A[d.cssClasses.LIST_ITEM_CLASS]
      ) && !o.classList.contains(
        A[d.cssClasses.ROOT]
      ); )
        o = o.parentElement;
      return o && o.classList.contains(
        A[d.cssClasses.LIST_ITEM_CLASS]
      ) && (t = e(m.ref).indexOf(o)), t;
    },
    [e, m.ref]
  ), { onClick: p } = i, q = O(
    (s) => {
      p == null || p(s);
      const o = S(s), t = !Y(
        s.target,
        d.strings.CHECKBOX_RADIO_SELECTOR
      );
      a.handleClick(o, t);
    },
    [S, a, p]
  ), { onKeyDown: L } = i, R = O(
    (s) => {
      L == null || L(s);
      const o = S(s);
      o >= 0 && a.handleKeydown(
        s,
        s.target instanceof Element && s.target.classList.contains(
          A[d.cssClasses.LIST_ITEM_CLASS]
        ),
        o
      );
    },
    [S, a, L]
  ), { onFocus: g } = i, w = O(
    (s) => {
      g == null || g(s), a.handleFocusIn(S(s));
    },
    [S, a, g]
  ), { onBlur: F } = i, y = O(
    (s) => {
      F == null || F(s), a.handleFocusOut(S(s));
    },
    [S, a, F]
  );
  m.setProp("onClick", q, !0), m.setProp("onKeyDown", R, !0), m.setProp("onFocus", w, !0), m.setProp("onBlur", y, !0);
  const N = O(() => {
    if (i.role)
      return I(i.role);
    if (!m.ref)
      return;
    const s = !!i.selectedIndex || !!m.ref.querySelector(`
        .${d.cssClasses.LIST_ITEM_ACTIVATED_CLASS},
        .${d.cssClasses.LIST_ITEM_SELECTED_CLASS}
      `), o = !!m.ref.querySelector(
      d.strings.CHECKBOX_SELECTOR
    ), t = !!m.ref.querySelector(
      d.strings.RADIO_SELECTOR
    );
    if (o)
      return I("group");
    if (t)
      return I("radiogroup");
    if (s)
      return I("listbox");
  }, [i.role, i.selectedIndex, m.ref]);
  return v(() => {
    a.layout(), N();
  }, [a, N]), v(() => {
    a.setWrapFocus(i.wrapFocus || i.wrapFocus === void 0);
  }, [a, i.wrapFocus]), v(() => {
    a.setVerticalOrientation(
      i.vertical || i.vertical === void 0
    );
  }, [a, i.vertical]), v(() => {
    i.selectedIndex !== void 0 && a.setSelectedIndex(i.selectedIndex);
  }, [a, i.selectedIndex]), v(() => {
    f && a.setSingleSelection(f === "listbox");
  }, [a, f]), { ...E, listItemClasses: r, setEnabled: (s, o) => {
    a.setEnabled(s, o);
  }, role: f };
}, U = j.createContext({
  getClassName: (i) => [],
  setEnabled: (i, e) => {
  }
}), he = x(function(e, n) {
  const {
    dense: r,
    twoLine: h,
    avatarList: f,
    apiRef: I,
    nonInteractive: a,
    onAction: E,
    foundationRef: m,
    wrapFocus: S,
    vertical: p,
    selectedIndex: q,
    children: L,
    ...R
  } = e, { rootEl: g, listItemClasses: w, setEnabled: F, role: y } = te(e), N = () => y === "group" ? { role: "checkbox" } : y === "radiogroup" ? { role: "radio" } : y === "listbox" ? { role: "option" } : {}, K = {
    getClassName: (c) => w[c] || [],
    setEnabled: F
  }, s = b(e, [
    "mdc-deprecated-list",
    {
      "mdc-deprecated-list--dense": r,
      "mdc-deprecated-list--two-line": h,
      "mdc-deprecated-list--avatar-list": f,
      "mdc-deprecated-list--non-interactive": a
    }
  ]), o = () => ["group", "radiogroup", "listbox"].some((c) => c === y), t = (c) => J(c) === "ListItem", l = (c) => t(c) ? C.cloneElement(c, {
    ...N(),
    ...C.isValidElement(c) ? c.props : {}
  }) : c;
  return /* @__PURE__ */ u(U.Provider, { value: K, children: /* @__PURE__ */ u(
    _,
    {
      tag: "ul",
      ...R,
      element: g,
      role: y,
      className: s,
      ref: n,
      children: o() ? C.Children.map(L, l) : L
    }
  ) });
}), W = ee({ surface: !1 })(
  x(function(e, n) {
    const r = C.createRef(), h = n ? Q(n, r) : r, f = C.useContext(U), [I, a] = C.useState(-1), E = C.useCallback(() => {
      const g = m(
        r.current
      );
      return g ? g.indexOf(r.current) : -1;
    }, [r]), m = (g) => {
      var w;
      return g ? [].slice.call(
        (w = g.parentNode) == null ? void 0 : w.querySelectorAll(".mdc-deprecated-list-item")
      ) : [];
    };
    C.useEffect(() => {
      r.current && I === -1 && a(E());
    }, [r, I, E]), C.useEffect(() => {
      I > -1 && e.disabled !== void 0 && f.setEnabled(I, !e.disabled);
    }, [I, e.disabled, f]);
    const { selected: S, activated: p, disabled: q, ...L } = e, R = b(e, [
      "mdc-deprecated-list-item",
      {
        "mdc-deprecated-list-item--selected": e.selected,
        "mdc-deprecated-list-item--activated": e.activated,
        "mdc-deprecated-list-item--disabled": e.disabled
      }
    ]);
    return /* @__PURE__ */ D(_, { tag: "li", tabIndex: 0, ...L, className: R, ref: h, children: [
      /* @__PURE__ */ u(B, { className: "mdc-deprecated-list-item__ripple" }),
      L.children
    ] });
  })
);
W.displayName = "ListItem";
const ne = x(
  function(e, n) {
    const r = b(e, ["mdc-deprecated-list-item__text"]);
    return /* @__PURE__ */ u(_, { tag: "span", ...e, ref: n, className: r });
  }
), se = x(
  function(e, n) {
    const r = b(e, [
      "mdc-deprecated-list-item__primary-text"
    ]);
    return /* @__PURE__ */ u(_, { tag: "span", ...e, ref: n, className: r });
  }
), ie = x(
  function(e, n) {
    const r = b(e, [
      "mdc-deprecated-list-item__secondary-text"
    ]);
    return /* @__PURE__ */ u(_, { tag: "span", ...e, ref: n, className: r });
  }
), re = x(
  function(e, n) {
    const r = b(e, [
      "mdc-deprecated-list-item__graphic"
    ]);
    return /* @__PURE__ */ u(V, { ...e, "aria-hidden": "true", ref: n, className: r });
  }
), ce = x(
  function(e, n) {
    const r = b(e, ["mdc-deprecated-list-item__meta"]);
    if (e.icon)
      return /* @__PURE__ */ u(V, { ...e, "aria-hidden": "true", ref: n, className: r });
    if (C.isValidElement(e.children)) {
      const { children: h, ...f } = e;
      return C.cloneElement(e.children, {
        ...f,
        ...e.children.props,
        className: X(r, e.children.props.className)
      });
    }
    return /* @__PURE__ */ u(_, { ...e, ref: n, className: r });
  }
), fe = x(
  function(e, n) {
    const r = b(e, ["mdc-deprecated-list-group"]);
    return /* @__PURE__ */ u(_, { ...e, ref: n, className: r, role: "group" });
  }
), Ie = x(
  function(e, n) {
    const r = b(e, [
      "mdc-deprecated-list-group__subheader"
    ]);
    return /* @__PURE__ */ u(_, { ...e, ref: n, className: r });
  }
), Ce = x(
  function(e, n) {
    const r = b(e, ["mdc-deprecated-list-divider"]);
    return /* @__PURE__ */ u(
      _,
      {
        tag: "li",
        role: "separator",
        ...e,
        ref: n,
        className: r
      }
    );
  }
), Se = x(
  ({ text: i, secondaryText: e, graphic: n, metaIcon: r, meta: h, children: f, ...I }, a) => {
    const E = i && e !== void 0 ? /* @__PURE__ */ u(se, { children: i }) : i, m = e !== void 0 ? /* @__PURE__ */ u(ie, { children: e }) : null;
    return /* @__PURE__ */ D(W, { ...I, ref: a, children: [
      /* @__PURE__ */ u(B, { className: "mdc-deprecated-list-item__ripple" }),
      n !== void 0 && /* @__PURE__ */ u(re, { icon: n }),
      m !== null ? /* @__PURE__ */ D(ne, { children: [
        E,
        m
      ] }) : E,
      (!!h || !!r) && /* @__PURE__ */ u(ce, { icon: r, children: h }),
      f
    ] });
  }
);
export {
  G as CollapsibleList,
  he as List,
  Ce as ListDivider,
  fe as ListGroup,
  Ie as ListGroupSubheader,
  W as ListItem,
  re as ListItemGraphic,
  ce as ListItemMeta,
  se as ListItemPrimaryText,
  ie as ListItemSecondaryText,
  ne as ListItemText,
  Se as SimpleListItem
};
